<template>
  <div class="confirmOrder">
    <!--买家身份-->
    <div class="clear confirm_order_item mar15_b" @click="identityShow = true">
      <span class="float-left fb">买家身份</span>
      <span class="float-right">
        <img class="identity_icon" v-if="identity.Enterprise === false" src="./images/confirm_order_person.png" alt="">
        <img class="identity_icon" v-else src="./images/confirm_order_enterprise.png" alt="">
        {{identity.Name}}
      </span>
    </div>
    <!--商品-->
    <div class="confirm_order_good mar15_b" v-for="(order,index) in orderShopData.orderList" :key="index">
      <p class="f12_rem fb gray_3 mar15_b">商家：{{order.shopName}}</p>
      <template v-for="(goods,index) in order.goodsList">
        <!--商品详情-->
        <div class="clear mar15_b" :key="index">
          <div class="float-left good_img">
            <img :src="`${goods.picUrl}?imageView2/1/w/65/h/65`" alt="">
          </div>
          <div class="float-left good_main">
            <p class="ellipsis_two f12_rem gray_3 box30 lin_15">
              <span class="good_label b_red" v-if="goods.isSelfOperated == 1">自营</span>
              <span class="good_label b_blue" v-if="goods.isOptimization == 1">优选</span>
              <span class="good_label b_red" v-if="goods.isPrescription == 1">处方药</span>
              <template v-if="goods.goodsTagList && goods.goodsTagList.length">
                <span class="h20 relative good_vip mar5_r" v-for="tag in goods.goodsTagList">{{tag}}</span>
              </template>
              {{goods.name}}
            </p>
            <p class="f11_rem gray_9 mar3_t lin_12">规格：{{goods.spec}}</p>
            <p class="clear mar3_t">
            <span class="red float-left f12_rem">
              <span>￥{{goods.marketPrice}}</span>
              <img class="good_vip_icon" v-if="goods.isVip == 1" src="./images/good_vip_icon.png" alt="">
            </span>
              <span class="float-right">x{{goods.goodsNum}}</span>
            </p>
            <p class="good_oldPrice" v-if="goods.marketPrice != goods.yPrice">￥{{goods.yPrice}}</p>
          </div>
        </div>
        <!--套餐/赠品-->
        <div class="clear cartGift mar15_b" v-if="goods.goodsGiftList.length > 0" :key="index">
          <span class="mui-pull-left f10_rem pad8_r lin_20 gray_3">套餐</span>
          <div class="mui-pull-left mar3_t">
            <p v-for="(giftGoods,index) in goods.goodsGiftList" :key="index">
              <a class="gray_2" :href="`/vm/goodDetails/${giftGoods.goodsId}`">
                <span class="w215 inlineblock ellipsis ver_text_bottom f10_rem gray_6">
                  {{giftGoods.name}}
                </span>
                <i class="iconfont icon-gengduo"></i>
              </a>
            </p>
          </div>
        </div>
      </template>
      <div class="good_more mar15_b">
        <span >更多商品</span>
        <van-icon name="arrow-down" size="14" />
      </div>
      <!--配送方式-->
      <div class="clear good_pickUp mar20_b f12_rem relative pad30_r">
        <span class="float-left fb">配送方式</span>
        <div class="float-right">
          <ul class="clear">
            <li :class="{pickUp_active:order.psSelected === true}" v-if="order.isPs" @click="distributionHandle(order,'ps')">卖家配送</li>
            <li :class="{pickUp_active:order.psSelected === false}" v-if="order.isZt" @click="distributionHandle(order,'zt')">买家自提</li>
          </ul>
          <span class="good_distribution_icon" @click="queryAddrList(order)">
            <img src="./images/good_distribution_icon.png" alt="">
          </span>
        </div>
      </div>
      <template v-if="order.psSelected">
        <!--收货地址-->
        <div class="confirm_order_address mar20_b" @click="toAddressList(order)">
          <p class="fb">收货地址</p>
          <p class="f12_rem mar5_b">
          </p>
          <p class="ellipsis_two mar5_b address_main">
            {{order.otherData.deliveryBUY.allName}}
          </p>
          <p class="pad15_l">
            <span class="mar15_r">{{order.otherData.deliveryBUY.name}}</span>
            <span>{{order.otherData.deliveryBUY.tel}}</span>
          </p>
        </div>
      </template>
      <template v-else>
        <!--自提地址-->
        <p class="mar20_b good_distribution clear f12_rem" @click="pickUpAddClick(order)">
          <span class="float-left fb">自提地址</span>
          <span class="float-right">{{order.otherData.deliveryVEN.allName}}{{order.otherData.deliveryVEN.addr}}</span>
        </p>
        <!--自提时间-->
        <div class="mar20_b clear f12_rem good_pickUp">
          <span class="float-left fb gray_3">自提时间</span>
          <div class="float-right">
            <ul class="clear">
              <li
                :class="{pickUp_active:index === pickUpTimeIndex}"
                v-for="(item , index) in pickUpTimeList"
                :key="index"
                @click="pickUpTimeClick(order,index)"
              >
                {{item}}
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template v-if="order.shopDtlEntity.isSupportCoupon==1 && order.isoa!=1 && !orderInfo.cusboId">
        <p class="mar20_b good_distribution clear f12_rem" @click="cashCouponDialog(order)"
           v-if="order.countsum > 0 && orderShopData.cashAmount > 0">
          <span class="float-left fb">现金券</span>
          <span class="float-right red">-¥{{order.deductedCashCoupon}}</span>
        </p>
        <p class="mar20_b good_distribution clear f12_rem"
           @click="shopCouponDialog(order)" v-if="order.coupRegularResList.length > 0 && order.isVip == 0">
          <span class="float-left fb">优惠券</span>
          <span class="float-right red">-¥{{order.shopCoupRegular.regVal}}</span>
        </p>
      </template>
      <!--礼券贺卡-->
      <div class="mar20_b" v-if="order.psSelected && order.shopDtlEntity.isOthersGoodsReceipt==1 && !orderInfo.cusboId">
        <p class="good_giftCard_hint mar15_b" v-if="order.isGiftCard">
          好友收到礼券贺卡，填写收货地址即可，请确认货品配送 区域后下单支付。
          <a href="javascript:;" @click="queryAddrList(order)">查看配送范围</a>
        </p>
        <p class="good_giftCard f12_rem clear">
          <span class="float-left fb flex_center">
            <span class="mar5_r" @click="giftExplainShow = true">礼券贺卡</span>
            <van-icon name="question-o" size="14" />
          </span>
          <span
            class="float-right good_giftCard_icon"
            :class="{giftCard_choose:order.isGiftCard}"
            @click="giftDialog(order)">
          </span>
        </p>
      </div>
      <!--处方药-->
      <p class="good_prescription f12_rem mar20_b" v-if="order.isPrescription" @click="prescriptionDialog(order)">上传处方药信息</p>
      <!--发票-->
      <div class="clear good_distribution f12_rem mar20_b" v-if="order.shopDtlEntity.isSupportInvoice == 1"
           @click="invoiceDialog(order)">
        <span class="float-left fb">开具发票</span>
        <span class="float-right" v-if="order.isReceipt">开发票</span>
        <span class="float-right" v-else>不开发票</span>
      </div>
      <div>
        <p class="gray_3 f12_rem mar10_b"><span class="fb">买家留言</span>（选填）</p>
        <textarea v-model="order.memo" placeholder="请写下想对卖家说的话"></textarea>
      </div>
    </div>
    <!--价格-->
    <div class="confirm_order_price mar15_b">
      <p class="clear mar5_b">
        <span class="float-left">货品总额</span>
        <span class="float-right">¥{{orderShopData.goodsPric}}</span>
      </p>
      <p class="clear mar5_b">
        <span class="float-left">价格优惠</span>
        <span class="float-right">-¥{{orderShopData.promoPric}}</span>
      </p>
      <p class="clear mar5_b">
        <span class="float-left">运费</span>
        <span class="float-right">+¥{{orderShopData.freightNew}}</span>
      </p>
      <p class="clear mar5_b">
        <span class="float-left">现金券</span>
        <span class="float-right red">-¥{{orderShopData.sumCouponMoney}}</span>
      </p>
    </div>
    <!--平台券-->
    <div class="clear confirm_order_item bor_f6" @click="platformCoupDialog"
         v-if="orderShopData.isVip === 0 && orderShopData.platformCoupRegularResList && orderShopData.platformCoupRegularResList.length > 0">
      <span class="float-left">平台券</span>
      <span class="float-right red">-¥{{orderShopData.platformCoupRegular.regVal}}</span>
    </div>
    <!--支付方式-->
    <div class="clear confirm_order_item bor_f6" @click="payWayShow = true">
      <span class="float-left fb">支付方式</span>
      <span class="float-right" v-if="orderShopData.paymentType === 1">在线支付</span>
      <span class="float-right" v-if="orderShopData.paymentType === 3">线下结算</span>
      <span class="float-right" v-if="orderShopData.paymentType === 4">暂不结算</span>
      <span class="float-right" v-if="orderShopData.paymentType === 5">赊销宝</span>
    </div>
    <!--底部导航-->
    <div class="confirm_order_tabbar">
      <span class="f12_rem">应付：<span class="f14_rem red">¥{{orderShopData.yfMoney}}</span></span>
      <span v-if="orderShopData.isSupportAmendprice === 1 && orderInfo.isGroup === 0 && orderShopData.isChangeP"
            class="tabbar_btn" @click="isShowPrompt = true">改价</span>
      <span class="tabbar_btn" @click="submitOrder">提交订单</span>
    </div>
    <!--切换买家身份-->
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="identityShow" :safe-area-inset-bottom="false" title="身份">
      <div class="content identity_pop pop_height">
        <ul>
          <li :class="{identity_item_active:item.IsDefault}" v-for="(item,index) in identityList" :key="index" @click="updateEnterprise(item)">
            <img class="identity_icon" v-if="item.Enterprise === false" src="./images/confirm_order_person.png" alt="">
            <img class="identity_icon" v-else src="./images/confirm_order_enterprise.png" alt="">
            {{item.Name}}
          </li>
        </ul>
        <div class="pop_btn">
          <span class="b_red white">确定</span>
        </div>
      </div>
    </van-action-sheet>
    <!--切换支付方式-->
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="payWayShow" :safe-area-inset-bottom="false" title="支付方式">
      <div class="content payWay_pop pop_height">
        <ul class="clear">
          <template v-if="orderShopData.map.paymentMethodList0 == 0">
            <li :class="{payWay_item_active:orderShopData.paymentType === 1}" @click="paymentMethod(1)">在线支付</li>
          </template>
          <template v-else>
            <li :class="{payWay_item_active:orderShopData.paymentType === 1}"
                v-if="orderShopData.map.paymentMethodList1 == 1" @click="paymentMethod(1)">
              在线支付
            </li>
            <li :class="{payWay_item_active:orderShopData.paymentType === 3}" @click="paymentMethod(3)"
                v-if="orderShopData.map.paymentMethodList2 == 2 && orderShopData.isAllowOfflineSettlement == 1">
              线下结算
            </li>
          </template>
          <li :class="{payWay_item_active:orderShopData.paymentType === 5}"
              v-if="orderShopData.isAllowSXB == 1" @click="paymentMethod(5)">
            赊销宝</li>
        </ul>
<!--        <div class="pop_btn">
          <span class="b_red white" @click="paymentConfirm">确定</span>
        </div>-->
      </div>
    </van-action-sheet>
    <!--开票-->
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="invoiceShow" :safe-area-inset-bottom="false" title="开票信息">
      <div class="content invoice_pop pop_height">
        <p class="gray_3 fb mar15_b f14_rem">发票类型</p>
        <ul class="clear invoice_way">
          <li class="invoice_item_active">纸质发票</li>
<!--          <li>电子发票</li>-->
        </ul>
        <div class="mar15_b">
          <van-field class="field_weight" v-model="orderInvoice.receipt" label="发票抬头" placeholder="请填写发票抬头" required />
          <van-field class="field_weight" v-model="orderInvoice.taxRegistrationNumber" label="纳税人识别号" placeholder="请填写纳税人识别号" required />
        </div>
<!--        <div class="mar15_b">
          <van-field class="field_weight" v-model="name" label="发票抬头" placeholder="请填写个人或企业名称" required />
          <van-field class="field_weight" v-model="name" label="纳税人识别号" placeholder="请填写个人或企业名称" required />
          <van-field v-model="name" label="单位地址" placeholder="请填写单位注册地址" />
          <van-field v-model="name" label="注册电话" placeholder="请填写单位注册电话" />
          <van-field v-model="name" label="开户行" placeholder="请填写开户银行" />
          <van-field v-model="name  " label="银行账户" placeholder="请填写银行账户" />
        </div>
        <div class="invoice_pop_operation clear">
          <span @click="invoiceAddShow = true">
            <img src="./images/invoice_pop_add.png" alt="">
            新增
          </span>
          <span @click="invoiceListShow = true">
            <img src="./images/invoice_pop_edit.png" alt="">
            更换开票人信息
          </span>
        </div>-->
        <div class="pop_btn">
          <span class="b_red white mar15_b" @click="invoiceConfirm">确定</span>
          <span class="red b_white bor_red" @click="invoiceCancel">不开发票</span>
        </div>
      </div>
    </van-action-sheet>
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="invoiceListShow" :safe-area-inset-bottom="false" title="开票信息">
      <div class="content invoice_pop pop_height">
        <ul class="invoice_list mar15_b">
          <li class="invoice_list_item">
            <p class="f12_rem gray_6"><span class="gray_3">发票抬头：</span>这是发票抬头</p>
            <div class="box10"></div>
            <p class="f12_rem gray_6"><span class="gray_3">纳税人识别号：</span>1231241241231421</p>
          </li>
          <li>
            <p class="f12_rem gray_6"><span class="gray_3">发票抬头：</span>这是发票抬头</p>
            <div class="box10"></div>
            <p class="f12_rem gray_6"><span class="gray_3">纳税人识别号：</span>1231241241231421</p>
          </li>
          <li>
            <p class="f12_rem gray_6"><span class="gray_3">发票抬头：</span>这是发票抬头</p>
            <div class="box10"></div>
            <p class="f12_rem gray_6"><span class="gray_3">纳税人识别号：</span>1231241241231421</p>
          </li>
        </ul>
        <div class="pop_btn">
          <span class="b_red white mar15_b" @click="invoiceListShow = false">确定</span>
          <span class="red b_white bor_red" @click="invoiceListShow = false">取消</span>
        </div>
      </div>
    </van-action-sheet>
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="invoiceAddShow" :safe-area-inset-bottom="false" title="开票信息">
      <div class="content invoice_pop pop_height">
        <div class="mar15_b">
          <van-field class="field_weight" v-model="name" label="发票抬头" placeholder="请填写个人或企业名称" required />
          <van-field class="field_weight" v-model="name" label="纳税人识别号" placeholder="请填写个人或企业名称" required />
          <van-field v-model="name" label="单位地址" placeholder="请填写单位注册地址" />
          <van-field v-model="name" label="注册电话" placeholder="请填写单位注册电话" />
          <van-field v-model="name" label="开户行" placeholder="请填写开户银行" />
          <van-field v-model="name" label="银行账户" placeholder="请填写银行账户" />
        </div>
        <div class="pop_btn">
          <span class="b_red white mar15_b" @click="invoiceAddShow = false">确定</span>
          <span class="red b_white bor_red" @click="invoiceAddShow = false">取消</span>
        </div>
      </div>
    </van-action-sheet>
    <!--上传处方药-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="prescriptionShow"
               position="bottom"
               :style="{ height: '100%' }">
      <div class="prescription_pop">
        <div class="prescription_pop_top"></div>
        <div class="prescription_pop_text padd_15">
          <p class="gray_3 f12_rem">您的订单包含处方药商品，根据《兽药处方药和非处方药管理方法》规定：</p>
          <p class="gray_3 f12_rem">A、如果您是经营的兽药门店、宠物用品经营单位、科研单位、学校、动物园、提供营业执照或者单位证明照片即可购买。</p>
          <p class="gray_3 f12_rem">B、如果南宁市养殖户或养殖场，需提供执业首医师开具的兽药处方药方可购买。</p>
          <p class="red f12_rem">注意：不能提供身份证明或者处方信息的，本店依照法规有权拒绝发货。</p>
        </div>
        <div class="prescription_pop_top"></div>
        <div class="padd_15">
          <p class="gray_3 mar15_b">请上传照片<span class="f12_rem gray_9">（最多5张）</span></p>
          <van-uploader v-model="fileList" :after-read="afterRead" :before-read="beforeRead" :max-count="maxCount" multiple result-type="file"/>
        </div>
        <div class="prescription_pop_btn">
          <span class="b_red bor_red white mar15_b" @click="prescriptionConfirm">确定</span>
          <span class="b_f7e8ea bor_red red" @click="prescriptionShow = false">返回</span>
        </div>
      </div>
    </van-popup>
    <!--切换自提地址-->
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="pickUpAddShow" :safe-area-inset-bottom="false" title="自提地址">
      <div class="content identity_pop pickUp_pop pop_height">
        <ul>
          <li :class="{identity_item_active:selectOrder.otherData.deliveryVEN.deliveryId === delivery.deliveryId}"
              v-for="(delivery,index) in selectOrder.shopDeliveryList" @click="selectPickUpAdd(delivery)" :key="index">
            <p>{{delivery.allName}}{{delivery.addr}}</p>
          </li>
        </ul>
        <div class="pop_btn">
          <span class="b_red white" @click="pickUpAddShow = false">确定</span>
        </div>
      </div>
    </van-action-sheet>
    <!--自提时间选择-->
    <!--eslint-disable-next-line-->
    <van-calendar v-model:show="pickUpTimeShow" @confirm="onConfirm" />
    <!--切换配送方式-->
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="distributionShow" title="配送方式">
      <div class="content distribution_pop">
        <div class="distribution_pop_main padd_15 pop_height">
          <template v-if="psDeliveryList.length > 0">
            <p class="f14_rem gary_3 fb">支持配送的区域：</p>
            <p class="f12_rem gary_3" v-for="shopDelivery in psDeliveryList" :key="shopDelivery.deliveryId">
              <span>{{shopDelivery.allName}}</span>
            </p>
          </template>
          <template v-if="ztDeliveryList.length > 0">
            <div class="box10"></div>
            <p class="f14_rem gary_3 fb">支持自提的地址：</p>
            <p class="f12_rem gary_3" v-for="(shopDelivery,index) in ztDeliveryList" :key="index">
              <span>{{shopDelivery.allName}}</span>
            </p>
          </template>
        </div>
      </div>
    </van-action-sheet>
    <!--点击选择现金券-->
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="cashCouponShow" :safe-area-inset-bottom="false" title="现金券抵扣">
      <div class="content cashCoupon_pop pop_height">
        <div>
          <p class="gray_3">剩余现金券：<span class="red">{{orderShopData.cashAmount}}</span>张</p>
          <p class="gray_3">本单可用：<span class="red">{{selectOrder.countsum}}</span>张</p>
          <p class="gray_3">用券抵扣：<input type="text" @change="cashCouponVerify" v-model="selectOrder.inputCashCoupon"/> 张</p>
        </div>
        <div class="pop_btn">
          <span class="bor_red red b_f7e8ea mar15_b" @click="cashCouponShow = false">暂不用券</span>
          <span class="b_red white bor_red" @click="cashCouponCalculate()">确定</span>
        </div>
      </div>
    </van-action-sheet>
    <!--礼券贺卡说明-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="giftExplainShow" round>
      <div class="gift_explain_pop">
        <p class="red f14">礼券贺卡说明</p>
        <div class="box30"></div>
        <p class="f13_rem gray_2">三步送心意</p>
        <div class="box30"></div>
        <ul>
          <li>
            <img src="./images/gift_explain_img1.png" alt="">
            <p>礼券贺卡</p>
            <p>商品挑选</p>
          </li>
          <li class="gift_explain_step">
            <img src="./images/gift_explain_step.png" alt="">
          </li>
          <li>
            <img src="./images/gift_explain_img2.png" alt="">
            <p>下单付款</p>
            <p>分享礼券贺卡</p>
          </li>
          <li class="gift_explain_step">
            <img src="./images/gift_explain_step.png" alt="">
          </li>
          <li>
            <img src="./images/gift_explain_img3.png" alt="">
            <p>好友填地址</p>
            <p>快递送到家</p>
          </li>
        </ul>
      </div>
    </van-popup>
    <!--优惠券-->
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="shopCouponShow" title="优惠">
      <div class="content cart_coupon_pop">
        <div class="cart_coupon_wrap pop_height">
          <div>
            <p class="gray_2 mar10_b">可领取的优惠券</p>
            <ul>
              <van-radio-group v-model="selectOrder.shopCoupRegular">
                <li class="clear" v-for="coupon in selectOrder.coupRegularResList" :key="coupon.cpId">
                  <div class="mui-pull-left coupon_left t_center">
                    <p class="white">￥<span class="f26_rem">{{coupon.regVal}}</span></p>
                    <p class="white f11_rem">满{{coupon.regKey}}可用</p>
                  </div>
                  <div class="mui-pull-left coupon_right">
                    <div class="mui-pull-left">
                      <p class="f12_rem gray_2">{{getTypeName(coupon)}}</p>
                      <div class="box20"></div>
                      <p class="f11_rem gray_9">{{coupon.useStartTimeStr}} - {{coupon.useEndTimeStr}} </p>
                    </div>
                    <van-radio :name="coupon" @click="shopCouponSelect(coupon)"></van-radio>
                  </div>
                </li>
              </van-radio-group>
            </ul>
          </div>
        </div>
      </div>
    </van-action-sheet>
    <!--平台券-->
    <!--eslint-disable-next-line-->
    <van-action-sheet v-model:show="platformCoupShow" title="优惠">
      <div class="content cart_coupon_pop">
        <div class="cart_coupon_wrap pop_height">
          <div>
            <ul>
              <van-radio-group v-model="orderShopData.platformCoupRegular">
                <li class="clear" v-for="coupon in orderShopData.platformCoupRegularResList" :key="coupon.cpId">
                  <div class="mui-pull-left coupon_left t_center">
                    <p class="white">￥<span class="f26_rem">{{coupon.regVal}}</span></p>
                    <p class="white f11_rem">满{{coupon.regKey}}可用</p>
                  </div>
                  <div class="mui-pull-left coupon_right">
                    <div class="mui-pull-left">
                      <p class="f12_rem gray_2">{{getTypeName(coupon)}}</p>
                      <div class="box20"></div>
                      <p class="f11_rem gray_9">{{coupon.useStartTimeStr}} - {{coupon.useEndTimeStr}} </p>
                    </div>
                    <van-radio :name="coupon" @click="platformCouponSelect(coupon)"></van-radio>
                  </div>
                </li>
              </van-radio-group>
            </ul>
          </div>
        </div>
      </div>
    </van-action-sheet>
    <van-dialog v-model="isShowPrompt" title="请输入实付金额"
                @cancel="promptCancel"
                @confirm="promptConfirm"
                show-cancel-button>
      <van-field
        v-model="inputBmoney"
        rows="2"
        label="金额"
        type="number"
      />
    </van-dialog>
    <addressList :addressListShow.sync="addressListShow" :selectDeliveryId.sync="selectDeliveryId"
                 :cusboId="this.orderInfo.cusboId"
                 :selectAddress="selectAddress" :updateAddress="updateAddress"
    />
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import { mapState } from "vuex";
import axios from "axios";
import common from "../../assets/js/common";
import addressList from "../addressList";
// import Index from '@/components/Exception';

export default {
  components: {
    addressList
    // Index,
  },

  data() {
    return {
      identityShow: false, // 是否显示切换买家身份
      payWayShow: false, // 是否显示支付方式
      invoiceShow: false, // 是否显示显示开票信息
      invoiceListShow: false, // 是否显示显示开票信息列表
      invoiceAddShow: false, // 是否显示显示开票信息新增
      prescriptionShow: false, // 是否显示显示上传处方药信息
      pickUpAddShow: false, // 是否显示显示切换自提地址
      pickUpTimeShow: false, // 是否显示显示切换自提地址
      distributionShow: false, // 是否显示显示切换配送方式
      cashCouponShow: false, // 是否显示现金券折扣
      shopCouponShow: false, // 是否显示店铺券折扣
      platformCoupShow: false, // 是否显示平台券折扣
      giftExplainShow: false, // 是否礼券贺卡说明
      addressListShow: false, // 是否展示收货地址列表
      isShowPrompt: false, // 改价展示
      selectDeliveryId: 0,
      name: "",
      fileList: [],
      maxCount: 5,
      pickUpTimeList: ["今天", "明天", "后天", "自定义"],
      pickUpTimeIndex: 0,
      distributionList: ["卖家配送", "买家自提"],
      distributionIndex: 0,
      orderInfo: {
        token: ""
      },
      orderShopData: {
        orderList: [],
        map: {},
        bmoney: ""
      },
      inputBmoney: "",
      query: {},
      identityList: [],
      identity: {},
      ztDeliveryList: [],
      psDeliveryList: [],
      // 当前选中的订单
      selectOrder: {
        goodsList: [],
        shopCoupRegular: {},
        invoice: {}
      },
      orderInvoice: {}, // 订单发票
      // 提交订单参数
      submitForm: ""
    };
  },
  mounted() {
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    this.query = this.$route.query;
    if (!common.isLogin(this.userInfo.id)) {
      return;
    }
    this.getConfirmOrderInfo();
    this.getEnterpriseList();
  },
  methods: {
    getConfirmOrderInfo() {
      Toast.loading({
        mask: true,
        message: "加载中...",
        duration: 0
      });
      const param = this.query;
      this.$store.dispatch("order/confirmOrder/getConfirmOrderInfo", this.$qs.stringify(param)).then((data) => {
        Toast.clear();
        this.orderInfo = data.data || {};
        const orderShopData = data.data.orderShopData || {};
        // 初始化数据
        const orderArray = [];
        if (orderShopData.orderList) {
          orderShopData.orderList.forEach((order) => {
            this.initDelivery(order);
            this.initOrderVariable(order);
            orderArray.push(order);
          });
        }
        this.initVariable(orderShopData);
        this.orderShopData = orderShopData;
        this.calculateOrderAmount(orderArray, true);
        // 处方药弹框
        if (this.orderInfo.isPrescription === 1) {
          Dialog.alert({
            message: "您的订单包含处方药商品，根据法律法规，上传处方或证明信息有误，卖家可取消订单，为避免影响您的正常交易，请上传处方或证明信息!",
            theme: "round-button"
          }).then(() => {
            // on close
          });
        }
      }).catch(() => {
        Toast.clear();
      });
    },
    // 初始化配送方式
    initDelivery(order) {
      // 配送方式
      order.psSelected = false; // 配送选择
      order.isPs = false;
      order.isZt = false;
      if (order.shopDtlEntity.shippingType === 1) {
        if (order.deliveryShow === 1 || order.deliveryShow === 3) {
          order.isPs = true;
        }
        order.psSelected = true;
      } else if (order.shopDtlEntity.shippingType === 2) {
        if (order.deliveryShow === 2 || order.deliveryShow === 3) {
          order.isZt = true;
        }
      } else if (order.shopDtlEntity.shippingType === 3) {
        if (order.deliveryShow === 1) {
          order.isPs = true;
          order.psSelected = true;
        } else if (order.deliveryShow === 2) {
          order.isZt = true;
        } else if (order.deliveryShow === 3) {
          order.isPs = true;
          order.isZt = true;
          if (!(this.orderInfo.cusboId || order.isoa === 1)) {
            order.psSelected = true;
          }
        }
      }
    },
    // 初始化变量
    initOrderVariable(order) {
      order.vipRebateCouponNum = 0; // 计算返券金额
      order.isPrescription = 0; // 处方药
      order.isVip = 0; // vip
      order.sum = 0; // 订单金额
      order.deductedCashCoupon = 0; // 现金券
      order.cmoney = 0; // 折扣券
      order.amoney = 0; // 预付款抵扣
      order.freight = 0; // 运费
      order.isGiftCard = false; // 是否是用礼券贺卡
      order.inputCashCoupon = "";
      order.goodsList.forEach((goods) => {
        // 返券金额
        if (goods.isVip === 1) {
          order.vipRebateCouponNum += goods.vipRebateCouponNum;
          order.isVip = goods.isVip;
        }
        // 处方药
        if (goods.isPrescription === 1) {
          order.isPrescription = goods.isPrescription;
          this.orderInfo.isPrescription = 1;
        }
        goods.goodsMoney = parseFloat(goods.marketPrice) * (goods.goodsNum * 1);
        order.sum += goods.goodsMoney;// 金额
      });
      order.shopCoupRegular = { regKey: 0, regVal: 0, cpId: 0 };// 默认店铺券
      order.invoice = {};// 发票
      order.isReceipt = false; // 是否开具发票
      order.isDelivery = false; // 代配送
      order.pickupTime = this.formatDate(new Date());
      order.fileList = [];
      if (!order.otherData.deliveryBUY) {
        order.otherData.deliveryBUY = {};
      }
    },
    // 初始化变量
    initVariable(orderShopData) {
      orderShopData.bmoney = "";
      // 支付类型默认值
      orderShopData.paymentType = 1;
      if (orderShopData.map.paymentMethodList0 === 0) {
        orderShopData.paymentType = 1;
      } else if (orderShopData.map.paymentMethodList1 === orderShopData.map.typeStr) {
        orderShopData.paymentType = 1;
      } else if (orderShopData.map.paymentMethodList3 === orderShopData.map.typeStr) {
        orderShopData.paymentType = 4;
      } else if (orderShopData.map.paymentMethodList2 === orderShopData.map.typeStr) {
        orderShopData.paymentType = 3;
      }
      orderShopData.isSubmit = 0; // 提交订单时，原价购买标识
      orderShopData.isSupportAmendprice = 1; // 是否支持改价
      orderShopData.isVip = 0;
      orderShopData.orderList.forEach((order) => {
        if (order.shopDtlEntity.isSupportAmendprice === 0) {
          orderShopData.isSupportAmendprice = 0;
        }
        if (order.isVip === 1) {
          orderShopData.isVip = 1;
        }
      });
      // 平台券
      let platformCoupRegular = { regKey: 0, regVal: 0 };
      if (orderShopData.isVip === 0 && orderShopData.platformCoupRegularResList && orderShopData.platformCoupRegularResList.length > 0) {
        platformCoupRegular = orderShopData.platformCoupRegularResList[0]; //eslint-disable-line
        platformCoupRegular.regKey = parseFloat(platformCoupRegular.regKey);
        platformCoupRegular.regVal = parseFloat(platformCoupRegular.regVal);
      }
      orderShopData.platformCoupRegular = platformCoupRegular;
      orderShopData.goodsPric = parseFloat(orderShopData.goodsPric).toFixed(2); // 格式化货品总额
      orderShopData.promoPric = parseFloat(orderShopData.promoPric).toFixed(2); // 优惠金额
    },
    // 改价取消
    promptCancel() {
      this.inputBmoney = "";
      this.isShowPrompt = false;
    },
    // 改价确认
    promptConfirm() {
      const money = this.inputBmoney;
      if (Number.isNaN(money) || parseFloat(money) <= 0) {
        Toast("修改价格式不正确");
        return;
      }
      const bmoney = parseFloat(money).toFixed(2);
      // 原总金额ymoney
      if (parseFloat(bmoney) > parseFloat(this.orderShopData.goodsPric) - parseFloat(this.orderShopData.promoPric)) {
        Toast("所修改的价格不能超过原总金额");
        return;
      }
      this.$set(this.orderShopData, "bmoney", bmoney);
      this.$set(this.orderShopData, "yfMoney", bmoney);
      this.isShowPrompt = false;
    },
    submitOrder() {
      // 获取参数
      const form = this.getOrderSubmitForm();
      if (!form) {
        return;
      }
      console.info(form);
      // 重复提交校验
      if (this.orderInfo.token) {
        Dialog.confirm({
          message: "订单已提交，请不要重复提交"
        }).then(() => {
          window.location.href = `${process.env.VUE_APP_APP}mob/order/person/orderListNew.do?type=1`;
        });
        return;
      }
      Toast.loading({
        mask: true,
        message: "加载中...",
        duration: 0
      });
      // 订单信息
      const compareAddress = [];
      this.orderShopData.orderList.forEach((orderItem) => {
        // 当选择配送地址 校验配送地址是否为空
        if (orderItem.psSelected && !orderItem.isGifts) {
          compareAddress.push(this.compareAddr(orderItem));
        }
      });
      // 比较地址
      Promise.all(compareAddress).then((data) => {
        for (const addr of data) {
          if (addr) {
            Toast("地址不在配送范围内");
            return;
          }
        }
        // 订单提交
        this.submitForm = JSON.stringify(form);
        let isFlag = 0;
        this.orderShopData.orderList.forEach((order) => {
          if (order.goodsGroupPurchaseId && order.goodsGroupPurchaseId > 0) {
            isFlag = order.goodsGroupPurchaseId;
          }
        });
        if (isFlag > 0) {
          this.promotionDtl(isFlag);
        } else {
          this.gotoPayment(0);
        }
      });
    },
    // 去支付。isYld 0 非原料商品支付， 1 原料商品 普通支付， 2原料商品 原料贷支付
    gotoPayment(isYld) {
      const form = this.submitForm;
      const { isGroupPurchase } = this.orderInfo;
      const platformCpId = this.orderShopData.platformCoupRegular.cpId;
      // 清空采购订货进货车
      sessionStorage.removeItem("recommendShopCheckGoods");
      const params = {
        order: form, bmoney: this.orderShopData.bmoney, dkmoney: "", isGroupPurchase, isMaterialPayment: isYld, isSubmit: this.orderShopData.isSubmit, platformCpId
      };
      console.info(params);
      this.$store.dispatch("order/confirmOrder/orderSubmit", this.$qs.stringify(params)).then((data) => {
        // 延迟关闭
        const timer = setInterval(() => {
          clearInterval(timer);
          Toast.clear();
        }, 1000);
        if (data.result.success) {
          this.orderInfo.token = "1";
          if (data.result.errorcode === "0") { // 一个订单跳转收银台
            if (data.isSecondReview) {
              Dialog.confirm({
                title: "提示",
                message: "该订单需要企联网二次审核，请确认订单无误后点击“去支付”发起支付申请"
              }).then(() => {
                window.location.href = `${process.env.VUE_APP_APP}mob/order/person/orderListNew.do?type=1`;
              });
              return;
            }
            if (!data.allowPayment) {
              Toast("您没有支付权限");
              window.location.href = `${process.env.VUE_APP_APP}mob/order/person/orderListNew.do?type=1`;
            } else {
              const url = `${process.env.VUE_APP_APP}mob/payment/chectout/cpCheckout.do`;
              const retUrl = `${url}?orderId=${data.orderId}`;
              const ua = navigator.userAgent.toLowerCase();
              if (ua.match(/MicroMessenger/i) == "micromessenger") { //eslint-disable-line
                this.toWxPay(retUrl, () => { Toast.clear(); },
                  () => { window.location.href = `${url}?orderId=${data.orderId}&wxsmallTage=1`; },
                  () => { window.location.href = retUrl; });
              } else {
                window.location.href = retUrl;
              }
            }
          } else if (data.result.errorcode === "1") { // 拆单 跳转订单列表页
            window.location.href = `${process.env.VUE_APP_APP}mob/order/person/orderListNew.do?type=1`;
          } else if (data.result.errorcode === 3) { // 代下单 跳转订单列表页
            if (this.orderInfo.isNew === "1") {
              // 去掉代客下单进货车
              sessionStorage.removeItem("customerRecommendShopCheckGoods");
              Toast("下单成功");
              setTimeout(() => {
                window.location.href = `${process.env.VUE_APP_APP}mobRecode/order/queryAgentOrderNew.do`;
              }, 2000);
            } else {
              window.location.href = `${process.env.VUE_APP_APP}mobRecode/order/queryAgentOrder.do`;
            }
          } else if (data.result.errorcode === "5") { // 鸡蛋订单 保证金充值跳转
            const param = {
              goodsId: data.req.goodsId,
              bizId: data.req.bizId,
              bizIdType: data.req.bizIdType,
              boId: data.req.boId,
              operatorBoId: data.req.operatorBoId,
              systemId: data.req.systemId,
              orderId: data.req.orderId,
              resultURL: data.req.resultURL,
              userType: data.req.userType,
              isMob: true
            };
            common.jumpTo(`${data.url}/margin/toRecharge.do`, param, { method: "post" });
          }
        } else {
          if (data.result.errorcode === "10") {
            this.orderShopData.isSubmit = 2;
          }
          Toast(data.result.errormsg);
        }
      }).catch(() => {

      });
    },
    /**
     * 微信环境支付
     * _retUrl 小程序跳转地址
     * _miniSuccess 商城小程序操作
     * _minifail 非商城小程序操作
     * _func 非小程序操作
     */
    toWxPay(_retUrl, _miniSuccess, _minifail, _func) {
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          // 跳转到小程序页面获取openId
          const uuid = common.guid();
          wx.miniProgram.navigateTo({
            url: `/pages/middleTrans/middleTrans?uuid=${uuid}&retUrl=${encodeURIComponent(_retUrl)}`,
            complete() {
              console.log("跳转到news页面complete");
              // 跳转小程序失败后的处理
              setTimeout(() => {
                common.getAppIdCache(uuid, _miniSuccess, _minifail);
              }, 3000);
            }
          });
        } else {
          _func();
        }
      });
    },
    promotionDtl(isFlag) {
      this.$store.dispatch("order/confirmOrder/promotionDtl", this.$qs.stringify({ id: isFlag })).then((data) => {
        const { goodsNum } = data;
        const { goodsPrice } = data;
        const { percent } = data;
        const sum = (goodsNum * goodsPrice * percent).toFixed(2);
        if (percent > 0) {
          Toast(`购买集采货品需要缴纳保证金，系统需要先从您的余额中冻结${sum}元作为本次交易的保证金后才能成功提交订单`);
          // $("#margin_one").html("购买集采货品需要缴纳保证金，系统需要先从您的余额中冻结"+sum+"元作为本次交易的保证金后才能成功提交订单");
          // $("#margin_two").html("¥ "+sum);
          // $("#margin_thr").html("保证金冻结金额=集采价*购买数量*"+percent*100+"%");
          Toast.clear();
        }
        if (percent === 0) {
          this.gotoPayment(0);
        }
      }).catch(() => {

      });
    },
    getOrderSubmitForm() {
      if (!common.isLogin(this.userInfo.id)) {
        return "";
      }
      let flag = true;
      const form = [];
      const checkGoodsName = [];
      // 支付方式
      const payment = this.orderShopData.paymentType;
      if (!payment) {
        Toast("支付方式不能为空");
        return "";
      }
      const cpIdList = [];
      // 订单信息
      for (const orderItem of this.orderShopData.orderList) {
        let goodsIds = "";
        const { deliveryId } = orderItem.otherData.deliveryBUY; // 收货地址
        const shopId = orderItem.shopIds;
        const isGifts = orderItem.isGiftCard ? 1 : 0; // 送礼订单
        const deliveryAreaId = orderItem.otherData.deliveryBUY.areaAxis; // 地址串Id
        const { isDelivery } = orderItem;// 是否代配送
        const { cpId } = orderItem.shopCoupRegular; // 店铺券ID
        if (cpId) {
          cpIdList.push(cpId);
        }
        if (isGifts === 1 && payment !== 1) {
          Toast("邀请他人收货 不支持 线下结算");
          flag = false;
          return "";
        }
        const cfyImgUrl = orderItem.fileList.join(","); // 处方药图片
        let isMaterial = ""; // 是否原料商品
        // 商品信息
        const orderCartEntity = [];
        const checkMargin = [];
        let isZero = false;
        orderItem.goodsList.forEach((goodsItem) => {
          const { goodsId } = goodsItem;
          goodsIds += `${goodsId},`;
          const sums = goodsItem.goodsNum;
          if (sums <= 0) {
            isZero = true;
          }
          const { promotionType } = goodsItem;
          const { promotionRemain } = goodsItem;
          if (promotionType && this.orderShopData.isSubmit === 0 && promotionType !== "BUY_GIFTS") {
            if (parseFloat(promotionRemain) > 0) {
              this.orderShopData.isSubmit = 1;
            }
          }
          checkMargin.push(goodsItem.isMargin);
          const { goodsName } = goodsItem;
          checkGoodsName.push(goodsName);
          isMaterial = goodsItem.isMaterial; //eslint-disable-line
          const orderCart = {
            goodsId,
            goodsQuantity: goodsItem.goodsNum,
            fromShopId: orderItem.fundShopIds,
            quantity: goodsItem.quantity,
            freightTemplateId: goodsItem.shopFreightTemplateId,
            transMode: goodsItem.shopFreightTemplateType,
            transModeType: goodsItem.shopFreightTransModeType,
            shareBoId: goodsItem.shareBoId,
            identifyingType: goodsItem.identifyingType,
            promotionType,
            yxGroupId: goodsItem.yxGroupId,
            isYxGroup: goodsItem.isYxGroup
          };
          orderCartEntity.push(orderCart);
        });
        orderItem.goodsIds = goodsIds;
        for (let i = 0; i < checkMargin.length; i++) { //eslint-disable-line
          const item = checkMargin[i];
          if (item === "1" && checkMargin.length !== 1) {
            const goodsName = checkGoodsName[i];
            Toast(`${goodsName}为保证金商品,` + '不能同时购买保证金商品与非保证金商品！'); //eslint-disable-line
            flag = false;
            return "";
          }
        }
        if (isZero) {
          Toast("商品数量小于等于0");
          flag = false;
          return "";
        }
        // 配送方式
        if (!orderItem.isPs && !orderItem.isZt) {
          Toast("卖家暂未设置配送方式，请联系商城客服：400-810-5353");
          flag = false;
          return "";
        }
        // 当选择配送地址 校验配送地址是否为空
        if (orderItem.psSelected && isGifts !== 1) {
          if (!deliveryId) {
            Toast("配送地址不能为空");
            flag = false;
            return "";
          }
          const { goodsFreightAmountRqNo } = orderItem;
          if (goodsFreightAmountRqNo === "002501") {
            Toast("该订单内存在购买的商品数量低于卖家设置的最小起运量，请重新下单");
            flag = false;
            return "";
          } if (goodsFreightAmountRqNo === "002502" || goodsFreightAmountRqNo === "002503") {
            Toast("该订单内存在商品未设置运费，请联系卖家解决");
            flag = false;
            return "";
          } if (goodsFreightAmountRqNo === "002504" || goodsFreightAmountRqNo === "002506") {
            Toast("该订单内存在多种运输方式，请单独进行购买");
            flag = false;
            return "";
          } if (goodsFreightAmountRqNo === "002507") {
            Toast("该订单内存在收货地址不在卖家配送范围内，请重新下单或联系卖家解决");
            flag = false;
            return "";
          } if (goodsFreightAmountRqNo === "002508") {
            Toast("请填写配送地址");
            flag = false;
            return "";
          } if (goodsFreightAmountRqNo === "-1") {
            Toast("系统原因导致提交订单失败，请联系平台客服 400-810-5353 进行处理");
            flag = false;
            return "";
          }
        }
        // 买家自提
        const pickupId = orderItem.otherData.deliveryVEN.deliveryId;
        const { pickupTime } = orderItem;
        if (!orderItem.psSelected) {
          if (!pickupId) {
            Toast("卖家自提地址不能为空");
            flag = false;
            return "";
          }
          if (!pickupTime) {
            Toast("自提时间不能为空");
            flag = false;
            return "";
          }
        }
        const order = {
          payment,
          cmoney: orderItem.cmoney, // 折扣券
          aMoney: orderItem.amoney, // 预付款抵扣金额
          cashMoney: orderItem.deductedCashCoupon, // 优惠券
          receipt: orderItem.invoice.taxRegistrationNumber,
          taxRegistrationNumber: orderItem.invoice.taxRegistrationNumber,
          shopId,
          logistics: orderItem.psSelected ? 1 : 2,
          memo: orderItem.memo ? orderItem.memo : "",
          pickupId,
          pickupTime,
          orderCartEntity,
          deliveryId,
          cusboId: this.orderInfo.cusboId,
          promotionId: orderItem.promotionId, // 促销ID
          goodsGroupPurchaseId: orderItem.goodsGroupPurchaseId, // 报名ID
          isGifts,
          isMaterial,
          deliveryAreaId,
          isDelivery,
          cpId,
          couponMoney: orderItem.shopCoupRegular.regVal, // 店铺券
          couponGoodsIds: orderItem.shopCoupRegular.subBusId, // 店铺券货品
          cfyImgUrl
        };
        form.push(order);
      }
      if (!flag) {
        return "";
      }
      if (this.isRepeat(cpIdList)) {
        Toast("多笔订单不可用同一张优惠券");
        return "";
      }
      return form;
    },
    compareAddr(orderItem) {
      const param = {
        deliveryId: orderItem.otherData.deliveryBUY.deliveryId,
        shopId: orderItem.fundShopIds,
        goodsIds: orderItem.goodsIds
      };
      return new Promise((resolve) => { //eslint-disable-line
        this.$store.dispatch("order/confirmOrder/compareAddr", this.$qs.stringify(param)).then((data) => {
          if (!data.isCanBoolean) { // 判断地址配送范围
            resolve(data);
          }
          resolve("");
        }).catch(() => {
          resolve("");
        });
      });
    },
    isRepeat(arr) {
      const hash = {};
      for (const arrElement of arr) {
        if (hash[arrElement]) {
          return true;
        }
        hash[arrElement] = true;
      }
      return false;
    },
    checkCouPon(order, num) {
      let shopCoup = { regKey: 0, regVal: 0 };
      const newArr = [];
      if (order.coupRegularResList && order.coupRegularResList.length > 0) {
        order.coupRegularResList.forEach((item) => {
          // 对数组各个数值求差值
          if (parseFloat(num) >= parseFloat(item.regKey)) {
            newArr.push(parseFloat(num) - parseFloat(item.regVal));
          } else {
            newArr.push(parseFloat(num) + parseFloat(item.regVal));
          }
        });
        // 求最小值的索引
        const index = newArr.indexOf(Math.min.apply(null, newArr));
        shopCoup = order.coupRegularResList[index];
        shopCoup.regKey = parseFloat(shopCoup.regKey);
        shopCoup.regVal = parseFloat(shopCoup.regVal);
      }
      return shopCoup;
    },
    // 配送处理
    distributionHandle(order, type) {
      // 配送方式 type值: ps zt
      this.$set(order, "psSelected", type === "ps");
      this.calculateOrderAmount(Array.of(order));
    },
    // 计算所有订单各项费用
    calculateOrderAmount(orderArray, isDefault) {
      const promiseArray = [];
      if (orderArray && orderArray.length > 0) {
        orderArray.forEach((item) => {
          this.queryShopByAxis(item);
          promiseArray.push(this.toFreightAmountNew(item, ""));
        });
      }
      Promise.all(promiseArray).then(() => {
        // 判断是否改过价
        if (this.orderShopData.bmoney) {
          this.$forceUpdate();
          return;
        }
        let freightNew = 0; // 运费总额
        let sumCmoney = 0; // 折扣券
        let sumAmoney = 0; // 预付抵扣金额
        let yfMoney = 0; // 应付金额
        let cashCouponMoney = 0; // 优惠券
        const platformCoupMoney = parseFloat(this.orderShopData.platformCoupRegular.regVal); // 平台券金额
        this.orderShopData.orderList.forEach((item) => {
          sumCmoney += item.cmoney;
          sumAmoney += item.amoney;
          if (item.psSelected) {
            freightNew += parseFloat(item.freight);
          }
          // 平台券
          if (isDefault && !this.orderShopData.platformCoupRegular.cpId) {
            this.$set(item, "shopCoupRegular", this.checkCouPon(item, this.orderShopData.goodsPric + freightNew));
          }
          cashCouponMoney += parseFloat(item.deductedCashCoupon) + parseFloat(item.shopCoupRegular.regVal);
        });
        yfMoney = parseFloat(this.orderShopData.goodsPric) + freightNew;
        yfMoney = yfMoney - sumCmoney - sumAmoney - parseFloat(this.orderShopData.promoPric);
        yfMoney = yfMoney - cashCouponMoney - platformCoupMoney;
        if (yfMoney <= 0) {
          yfMoney = 0;
        }
        this.$set(this.orderShopData, "platformCoupMoney", platformCoupMoney);
        this.$set(this.orderShopData, "freightNew", freightNew.toFixed(2));
        this.$set(this.orderShopData, "sumCmoney", sumCmoney.toFixed(2));
        this.$set(this.orderShopData, "sumAmoney", sumAmoney.toFixed(2));
        this.$set(this.orderShopData, "sumCouponMoney", cashCouponMoney + platformCoupMoney);
        this.$set(this.orderShopData, "yfMoney", yfMoney.toFixed(2));
        this.$set(this.orderShopData, "dkmoney", sumAmoney.toFixed(2));
        this.$forceUpdate();
      });
    },
    selectPickUpAdd(delivery) {
      this.selectOrder.otherData.deliveryVEN = delivery;
      this.pickUpAddShow = false;
      this.$forceUpdate();
    },
    pickUpAddClick(order) {
      this.pickUpAddShow = true;
      this.selectOrder = order;
    },
    toFreightAmountNew(order, transMode) {
      if (!order.psSelected) {
        return;
      }
      let flag = true;
      const deliveryBUY = order.otherData.deliveryBUY || {};
      const deliveryAreaId = deliveryBUY.areaAxis;
      const { deliveryId } = deliveryBUY;
      if (deliveryId == null || deliveryAreaId === "" || deliveryAreaId === "undefined") {
        order.goodsFreightAmountRqNo = "002508";
        flag = false;
      }
      let areaId = null;
      if (deliveryAreaId && deliveryAreaId.split("$")[2]) {
        areaId = deliveryAreaId.split('$')[2]; //eslint-disable-line
      }
      const goodsList = [];
      const tIds = [];
      order.goodsList.forEach((goods) => {
        const { shopFreightTemplateId } = goods;
        if (!shopFreightTemplateId) {
          order.goodsFreightAmountRqNo = "002502";
          flag = false;
        }
        goodsList.push({
          tId: goods.shopFreightTemplateId,
          refId: order.fundShopIds,
          goodsId: goods.goodsId,
          areaId,
          num: goods.goodsNum,
          weight: goods.goodsNum,
          goodsMoney: goods.goodsMoney,
          areaAxis: deliveryAreaId,
          transMode,
          goodsPrice: goods.marketPrice,
          deliveryId
        });
        tIds.push(shopFreightTemplateId);
      });
      if (!flag) {
        order.freight = 0.00;
        // $(".tofreightMoney", _this).html('具体运费请联系卖家');
        return;
      }
      const param = {
        goodsList: JSON.stringify(goodsList),
        tIds: JSON.stringify(tIds),
        subBusIdList: order.shopCoupRegular.subBusId ? order.shopCoupRegular.subBusId : "0",
        couponMoney: order.shopCoupRegular.regVal ? order.shopCoupRegular.regVal : 0,
        cusboId: this.orderInfo.cusboId ? this.orderInfo.cusboId : ""
      };
      return new Promise((resolve) => { //eslint-disable-line
        this.$store.dispatch("order/confirmOrder/toFreightAmountNew", this.$qs.stringify(param)).then((data) => {
          order.goodsFreightAmountRqNo = `${data.GoodsFreightAmount}`;
          if (data.paramFreight && data.paramFreight.length > 0) {
            for (const item of data.paramFreight) {
              if (item.type === "ZDYYF" && item.transModeType[0] !== "KD") { // 汽运/火运/船运
                // $("#feightAmountCheck",_this).show();
                /* let _html = '';
                for (const transModeTypeItem of item.transModeType) {
                  let transModeCn = '';
                  if (transModeTypeItem === 'QY') {
                    transModeCn = '汽运';
                  } else if (transModeTypeItem === 'HY') {
                    transModeCn = '火运';
                  } else if (transModeTypeItem === 'CY') {
                    transModeCn = '船运';
                  }
                  if (transModeTypeItem === item.transModeSelect) {
                    _html += `<em class="f12 cur" onclick="toRecalculationAmount('${transModeTypeItem}',this)" data-id="${transModeTypeItem}">${transModeCn}</em>`;
                  } else {
                    _html += `<em class="f12" onclick="toRecalculationAmount('${transModeTypeItem}',this)" data-id="${transModeTypeItem}">${transModeCn}</em>`;
                  }
                } */
                // $("#feightAmountCheck .d_ysfs",_this).append(_html);
                if (data.GoodsFreightAmount !== "-1") {
                  // $(".tofreightMoney", _this).html('运费' + parseFloat(data.GoodsFreightAmount).toFixed(2) + '元');
                } else {
                  // $(".tofreightMoney", _this).html("");
                }
                break;
              }
            }
          }
          if (data.GoodsFreightAmount === "002501" || data.GoodsFreightAmount === "002502"
            || data.GoodsFreightAmount === "002503" || data.GoodsFreightAmount === "002504"
            || data.GoodsFreightAmount === "002506" || data.GoodsFreightAmount === "002507" || data.GoodsFreightAmount === "-1") {
            this.$set(order, "freight", 0.00);
            // $(".tofreightMoney", _this).html('具体运费请联系卖家');
            resolve("");
          }
          order.goodsList.forEach((goods) => {
            if (data.goodsFreightAmountRq && data.goodsFreightAmountRq.data && data.goodsFreightAmountRq.data.goodsFreightResFormList) {
              const goodsAmount = data.goodsFreightAmountRq.data.goodsFreightResFormList;
              goodsAmount.forEach((goodsAmountItem) => {
                if (goods.goodsId === goodsAmountItem.goodsId) {
                  goods.shopFreightTemplateType = goodsAmountItem.type;
                  goods.goodsFeightAmount = parseFloat(goodsAmountItem.freightMoney).toFixed(2);
                  goods.shopFreightTransModeType = goodsAmountItem.transMode;
                }
              });
            }
          });
          this.$set(order, "freight", parseFloat(data.GoodsFreightAmount).toFixed(2));
          console.info(order.freight);
          resolve("");
          // $(".tofreightMoney", _this).html('运费'+parseFloat(data.GoodsFreightAmount).toFixed(2)+'元');
        }).catch(() => {
          resolve("");
        });
      });
    },
    prescriptionDialog(order) {
      this.prescriptionShow = true;
      this.selectOrder = order;
      this.fileList = [];
      this.selectOrder.fileList.forEach((item) => {
        this.fileList.push({
          url: item
        });
      });
    },
    prescriptionConfirm() {
      this.prescriptionShow = false;
      const newFileList = [];
      let isHaveFile = false;
      this.fileList.forEach((file) => {
        if (file.url) {
          isHaveFile = true;
          newFileList.push(file.url);
        }
      });
      if (!isHaveFile) {
        Toast("请上传图片信息");
        return;
      }
      this.$set(this.selectOrder, "fileList", newFileList);
    },
    // 平台券弹框
    platformCoupDialog() {
      this.platformCoupShow = true;
    },
    platformCouponSelect() {
      this.platformCoupShow = false;
      // this.selectOrder.shopCoupRegular = coupon;
      // this.$set(this.selectOrder, 'deductedCashCoupon', 0);
      this.calculateOrderAmount();
    },
    // 店铺券弹框
    shopCouponDialog(order) {
      this.shopCouponShow = true;
      this.selectOrder = order;
    },
    shopCouponSelect() {
      this.shopCouponShow = false;
      // this.selectOrder.shopCoupRegular = coupon;
      this.$set(this.selectOrder, "deductedCashCoupon", 0);
      this.calculateOrderAmount();
    },
    // 现金券弹框
    cashCouponDialog(order) {
      this.cashCouponShow = true;
      this.selectOrder = order;
      this.$set(this.selectOrder, "inputCashCoupon", this.selectOrder.deductedCashCoupon > 0 ? this.selectOrder.deductedCashCoupon : "");
    },
    cashCouponCalculate() {
      this.cashCouponShow = false;
      const cashCoupon = this.selectOrder.inputCashCoupon;
      this.$set(this.selectOrder, "deductedCashCoupon", cashCoupon || 0);
      // 现金券
      if (cashCoupon && parseFloat(cashCoupon) > 0) {
        // 店铺券设置为空
        this.selectOrder.shopCoupRegular = { regKey: 0, regVal: 0, cpId: 0 };
      }
      this.calculateOrderAmount();
    },
    // 现金券校验
    cashCouponVerify() {
      let value = this.selectOrder.inputCashCoupon || "0";
      value = value.replace(/[^\d.-]/g, "");
      value = parseInt(value, 10);
      value = value < 0 ? 0 : value;
      if (value > this.selectOrder.sum) {
        value = 0;
        Toast("使用的优惠券超过本店铺商品的总额");
      }
      if (value > this.selectOrder.countsum) {
        value = 0;
        Toast("使用的优惠券超过本店铺商品使用优惠券数");
      }
      // 现金券总数
      let allCashCoupon = 0;
      this.orderShopData.orderList.forEach((order) => {
        if (order.inputCashCoupon) {
          allCashCoupon += parseFloat(order.inputCashCoupon);
        }
      });
      if (parseFloat(allCashCoupon) > parseFloat(this.orderShopData.cashAmount)) {
        value = 0;
        Toast("优惠券不足");
      }
      this.$set(this.selectOrder, "inputCashCoupon", value);
      this.$forceUpdate();
    },
    // 支付方式选择
    paymentMethod(paymentType) {
      this.$set(this.orderShopData, "paymentType", paymentType);
      this.payWayShow = false;
    },
    //  支付方式确认
    paymentConfirm() {
      this.payWayShow = false;
    },
    // 发票选择
    invoiceDialog(order) {
      this.invoiceShow = true;
      this.selectOrder = order;
      this.orderInvoice = this.selectOrder.invoice;
      if (!this.selectOrder.isReceipt) {
        this.orderInvoice = {};
        this.$set(this.selectOrder, "invoice", {});
      }
    },
    // 发票确认
    invoiceConfirm() {
      if (!this.orderInvoice.receipt || this.orderInvoice.receipt.trim() === "") {
        Toast("请填写发票抬头");
        return;
      }
      if (!this.orderInvoice.taxRegistrationNumber || this.orderInvoice.taxRegistrationNumber === "") {
        Toast("请填写纳税人识别号");
        return;
      }
      this.invoiceShow = false;
      this.$set(this.selectOrder, "isReceipt", true);
      // Object.assign({}, this.orderInvoice)
      this.$set(this.selectOrder, "invoice", this.orderInvoice);
    },
    // 发票取消
    invoiceCancel() {
      this.invoiceShow = false;
      this.$set(this.selectOrder, "isReceipt", false);
      this.$set(this.selectOrder, "invoice", {});
    },
    // 贺卡选择
    giftDialog(order) {
      order.isGiftCard = !order.isGiftCard;
      this.$forceUpdate();
    },
    queryShopByAxis(order) {
      if (!order.psSelected) {
        return;
      }
      const deliveryBUY = order.otherData.deliveryBUY || {};
      const param = {
        areaAxis: deliveryBUY.areaAxis
      };
      this.$store.dispatch("order/confirmOrder/queryShopByAxis", this.$qs.stringify(param)).then((data) => {
        console.info(data);
      }).catch(() => {
      });
    },
    queryAddrList(order) {
      const goodsIds = [];
      order.goodsList.forEach((goods) => {
        goodsIds.push(goods.goodsId);
      });
      const param = {
        shopId: order.shopIds,
        goodsIds: goodsIds.join(",")
      };
      this.$store.dispatch("order/confirmOrder/queryAddrList", this.$qs.stringify(param)).then((data) => {
        this.distributionShow = true;
        if (data.deliveryList1 && order.isPs) {
          this.psDeliveryList = data.deliveryList1;
        }
        if (data.deliveryList2 && order.isZt) {
          this.ztDeliveryList = data.deliveryList2;
        }
      }).catch(() => {
      });
    },
    getEnterpriseList() {
      this.$store.dispatch("order/confirmOrder/getEnterpriseList", this.$qs.stringify({})).then((data) => {
        this.identityList = [];
        const newData = data.data || [];
        const personIdentity = {
          ID: this.userInfo.idStr,
          IsDefault: false,
          Name: this.userInfo.realName,
          Enterprise: false
        };
        newData.unshift(personIdentity);
        // 企业身份
        let identity = {};
        newData.forEach((item) => {
          // 存在默认身份
          if (item.IsDefault) {
            identity = item;
          }
        });
        // 不存在
        if (!identity.ID) {
          personIdentity.IsDefault = true;
          identity = personIdentity;
        }
        this.identityList = newData;
        this.identity = identity;
      }).catch(() => {
      });
    },
    // 切换身份
    updateEnterprise(item) {
      this.$set(item, "IsDefault", true);
      this.$store.dispatch("order/confirmOrder/updateEnterprise", { enterpriseId: item.ID }).then(() => {
        this.identityShow = false;
        this.identityList.forEach((identity) => {
          this.$set(identity, "IsDefault", identity.ID === item.ID);
        });
        this.identity = item;
        this.$router.go(0);
      }).catch(() => {
      });
    },
    pickUpTimeClick(order, index) {
      this.selectOrder = order;
      this.pickUpTimeIndex = index;
      this.pickUpTimeShow = index === 3;
      // '今天', '明天', '后天', '自定义'
      const currentTime = new Date();
      if (index === 0) {
        currentTime.setTime(currentTime.getTime());
      }
      if (index === 1) {
        currentTime.setTime(currentTime.getTime() + 24 * 60 * 60 * 1000);
      }
      if (index === 2) {
        currentTime.setTime(currentTime.getTime() + 48 * 60 * 60 * 1000);
      }
      if (index === 3) {
        this.$set(this.selectOrder, "pickupTime", "");
      }
    },
    // 自提时间选择
    onConfirm(value) {
      this.pickUpTimeList[3] = this.formatDate(value);
      this.pickUpTimeShow = false;
      this.$set(this.selectOrder, "pickupTime", this.formatDate(value));
    },
    updateAddress(address) {
      if (!address || !address.deliveryId) {
        return;
      }
      this.orderShopData.orderList.forEach((order) => {
        const { deliveryBUY } = order.otherData;
        if (deliveryBUY && deliveryBUY.deliveryId === address.deliveryId) {
          order.otherData.deliveryBUY = address;
        }
      });
    },
    selectAddress(address) {
      if (!address || !address.deliveryId) {
        return;
      }
      this.selectOrder.otherData.deliveryBUY = address;
      this.calculateOrderAmount(Array.of(this.selectOrder));
      this.addressListShow = false;
    },
    // 跳转地址列表
    toAddressList(order) {
      this.selectOrder = order;
      this.addressListShow = true;
      this.selectDeliveryId = 0;
      if (this.selectOrder.otherData.deliveryBUY) {
        this.selectDeliveryId = this.selectOrder.otherData.deliveryBUY.deliveryId;
      }
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    getTypeName(coupon) {
      let couponTypeName = "";
      if (coupon.busId.indexOf("SHOP#FFFF") !== -1) {
        if (coupon.regVal === coupon.regKey) {
          couponTypeName = "全品类(特例商品除外)";
        } else {
          couponTypeName = "全平台通用优惠券";
        }
      } else if (coupon.busType === "SHOP") {
        couponTypeName = "全店通用";
      } else if (coupon.busType === "GOODS") {
        couponTypeName = "店铺指定商品可用";
      } else if (coupon.busType === "CATE") {
        couponTypeName = "指定分类商品可用";
      }
      return couponTypeName;
    },
    afterRead(file) {
      const count = this.selectOrder.fileList.length;
      let fileArray = [];
      if (Array.isArray(file)) {
        fileArray = file;
        if (file.length + count > this.maxCount) {
          fileArray = file.slice(0, this.maxCount);
        }
      } else {
        fileArray.push(file);
      }
      fileArray.forEach((item) => {
        item.status = "uploading";
        item.message = "上传中...";
        // 此时可以自行将文件上传至服务器
        const formData = new FormData(); // 声明一个FormData对象
        formData.append("file", item.file);
        axios.post(`${process.env.VUE_APP_APP}file/uploadFile.do`, formData, {
          headers: { "content-type": "multer/form-data" }
        }).then((res) => {
          item.status = "";
          item.message = "";
          const fileUrl = res.data.substring(res.data.indexOf("http"));
          item.url = fileUrl;
        }).catch(() => {
          file.status = "failed";
          file.message = "上传失败";
        });
      });
    },
    // 返回布尔值
    beforeRead(file) {
      let fileArray = [];
      if (Array.isArray(file)) {
        fileArray = file;
      } else {
        fileArray.push(file);
      }
      for (const item of fileArray) {
        if (item.size && item.size >= 10 * 1024 * 1024) {
          Toast("上传文件过大，文件大小不能大于10M");
          return false;
        }
        if (item.type !== "image/jpeg" && item.type !== "image/jpg" && item.type !== "image/png" && item.type !== "image/gif") {
          Toast("请上传格式图片");
          return false;
        }
      }
      return true;
    }
  }
};
</script>


<style lang="scss" scoped>
  @import './style.scss';
</style>
